// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_styles_hero__2EJzt","heroImage":"Hero_styles_heroImage__2PYML"};